import { getCards, deleteCards } from '@vlabs/api/point-api/client';

import type { CardId } from '@vlabs/api/point-api/model';

export async function deleteAllCardsFromList(id: string): Promise<void> {
  const pageSize = 1000;

  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const cardsResponse = await getCards({
      list_ids: [id],
      targets: ['card_id'],
      page_size: pageSize,
    });

    const cardIds = cardsResponse.cards?.map(({ card_id }) => card_id) ?? [];

    if (!cardIds.length) {
      break;
    }

    // eslint-disable-next-line no-await-in-loop
    await deleteCards({
      card_ids: cardIds as CardId[],
    }, { ignore: 1 });

    if (cardIds.length < pageSize) {
      break;
    }
  }
}
